import { ModalRoute } from '@circlefin/modal-router'
import { EntitySwitcher } from '@features/accounts/modals'
import { routes } from '@services/sections/modal'

/**
 * Entity Switcher Modal Router.
 */
export const EntitySwitcherRouter: React.FC = () => {
  return (
    <ModalRoute
      content={<EntitySwitcher />}
      path={routes.account.entitySwitcher.entitySwitcher}
    />
  )
}
